export default __webpack_public_path__ + "static/media/SDG-icon-NL-03.476602e2.svg";